import { render, staticRenderFns } from "./AddTrailer.vue?vue&type=template&id=1d16645a&"
import script from "./AddTrailer.vue?vue&type=script&lang=js&"
export * from "./AddTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports